import React from 'react'

import { useDirectTask } from '@frame/lib/hooks/useDirectTask'
import { DataAttribute } from '@frame/types'

import { ConnectorScreen } from './connector-screen'

export function Credentials() {
  const task = useDirectTask()

  return <ConnectorScreen data-cy={DataAttribute.SCREEN_TASKS} task={task} />
}
